/**
 * Convert string to string array or return string array
 * @param rowContent
 */
export var convertStringToArray = function (rowContent) {
    if (!Array.isArray(rowContent)) {
        return [rowContent];
    }
    return rowContent;
};
/**
 * Check if component has first element
 * @param props
 */
export var hasFirstElement = function (props) {
    return !!props.icon;
};
//# sourceMappingURL=row.core.js.map